// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const recipeHit = (item, classes = 'g-col-12 g-col-md-6') => {
  const { url, title, images, restorationTypes, recipeOtherFilters } = item

  return `
    <article class="feed-recipe ${classes}${
      images.large ? ' has-post-thumbnail' : ''
    }">
        <a href="${url}" class="feed-recipe__wrapper">
           <div class="feed-recipe__thumbnail">
              ${
                images.medium
                  ? `<img src="${images.medium}" alt="${title}" />`
                  : '<div class="feed-recipe__image-placeholder"></div>'
              }
          
              ${
                restorationTypes.length
                  ? `
                  <div class="restoration-types">
                    ${restorationTypes.map((restorationType) => {
                      return `
                      <div class="restoration-types__single">
                       ${
                         restorationType.icon.medium
                           ? `<img src="${restorationType.icon.medium}" alt="${restorationType.name}" />`
                           : ''
                       }
                       <span class="restoration-types__short-title">${
                         restorationType.shortTitle ?? restorationType.name
                       }</span>
                      </div>
                      `
                    })}
                  </div>
                  `
                  : ''
              }
              
            <div class="feed-recipe__icon-wrapper">
              ${
                recipeOtherFilters.length
                  ? `
                    ${recipeOtherFilters.map((recipeOtherFilter) => {
                      return `
                      <div class="drap-icon">
                       ${
                         recipeOtherFilter.icon.medium
                           ? `<img src="${recipeOtherFilter.icon.medium}" alt="${recipeOtherFilter.name}" />`
                           : ''
                       }
                      </div>
                      `
                    })}
                    `
                  : ''
              }
              <span class="click-icon"><i class="vn-icons-click"></i></span>
            </div>
          </div>
          
          <span class="feed-recipe__title">${
            item._highlightResult.title.value
          }</span>
          
          <span class="drap-btn">
            <span class="vn-a-content">${__('Discover the recipe', 'vn')}</span>
            <span class="vn-a-icon">
                <i class="vn-icons-arrow-right-circle"></i>
            </span>
          </span>
        </a>
    </article>
  `
}

const recipeButtun = {}
recipeButtun.textContent = __('Load more recipes', 'vn')

export { recipeHit, recipeButtun }
